// extracted by mini-css-extract-plugin
module.exports = {"card-collection-container":"Home_card-collection-container__33YYh"};